import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Tesorería y ventas",
    items: [
      { label: "Bancos",        icon: "fas fa-university",          href: "/Bancos",        key: "admin.bancos.ver" },
      { label: "Ventas",        icon: "fas fa-money-bill-wave",     href: "/ListadoVentas", key: "admin.ventas.ver" },
      { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", href: "/EstadoCuenta",  key: "admin.estadoCuenta.ver" },
      { label: "Abonos",        icon: "fas fa-dollar-sign",         href: "/ListadoAbonos", key: "admin.abonos.ver" },
    ],
  },
  {
    title: "Documentos",
    items: [
      { label: "Notas de Cargo", icon: "fas fa-money-check-alt", href: "/ListadoNotasCargo",        key: "admin.notasCargo.ver" },
      { label: "Devoluciones",   icon: "fas fa-undo-alt",        href: "/ListadoDevolucionesAdmin", key: "admin.devoluciones.ver" },
    ],
  },
  {
    title: "Catálogos",
    items: [
      { label: "Conceptos Bonificaciones", icon: "fas fa-bars",         href: "/ListadoConceptosBonificaciones", key: "admin.conceptosBonificaciones.ver" },
      { label: "Bonificaciones",           icon: "fas fa-search-dollar", href: "/ListadoBonificaciones",         key: "admin.bonificaciones.ver" },
      { label: "Empresas",                 icon: "fas fa-industry",      href: "/ListadoEmpresas",               key: "admin.empresas.ver" },
    ],
  },
];

function BotonesAdmin() {
  return (
    <MenuGrid
      title="Admin"
      subtitle="Tesorería, ventas, estados de cuenta y catálogos"
      icon="fas fa-file-invoice-dollar"
      accent={{ color: "#10b981", bg: "#f0fdf4" }}
      modulo="admin"
      sections={SECTIONS}
    />
  );
}

export default BotonesAdmin;
